import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';

export const Box = (props: MuiBoxProps): JSX.Element => {
  return <MuiBox {...props} />;
};

export default Box;
